import { createSlice, PayloadAction  } from '@reduxjs/toolkit';
import { RootState } from '../store';

type ModalState = {
types: string[];
data: Record<string, unknown>;
}

type OpenModalPayload = {
  type: string;
  data?: unknown;
}

type CloseModalPayload = {
  type: string;
}

const initialState:ModalState = {
  types: [],
  data: {},
}

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<OpenModalPayload>) => {
      state.types = [...state.types, action.payload.type]
      state.data = {
        ...state.data,
        [action.payload.type]: action.payload.data,
      }
    },
    closeModal: (state, action: PayloadAction<CloseModalPayload>) => {
      state.types = state.types.filter(type => action.payload.type !== type)
      const newData = { ...state.data }
      delete newData[action.payload.type]
      state.data = newData
    },
    closeAllModal: (state) => {
      state.types = initialState.types
      state.data = initialState.data
    },
  },

})
export default modalsSlice.reducer

export const selectModalState = (state:RootState) => state.modal
export const { openModal, closeModal, closeAllModal } = modalsSlice.actions